<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="DED">For Roger, Dana, and Alex—with much love</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?38eec556